/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
  ) {}

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.showYbug();
    this.preventZooming();
  }

  preventZooming() {
    document.addEventListener('gesturestart', (event) => event.preventDefault());
    document.addEventListener('gesturechange', (event) => event.preventDefault());
    document.addEventListener('gestureend', (event) => event.preventDefault());

    // Prevent double-tap zooming
    let lastTouchEnd = 0;
    document.addEventListener(
      'touchend',
      (event) => {
        const now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false,
    );
  }

  showYbug() {
    window['ybug_settings'] = {
      id: 'bwv49snfsd0301j8vhw0',
      shortcut: true,
      launcher_position: 'right-bottom',
      widget_position: 'right',
      comment: true,
      comment_required: true,
      name: true,
      name_required: true,
      email: true,
      email_required: true,
      skip_to: 'feedback',
      close_countdown: false,
      title: true,
      title_required: false,
      priority: true,
      priority_required: false,
      translate: {
        'launcherButton.Title': 'Feedback',
        'feedbackTypeForm.Heading': 'Feedback',
        'feedbackTypeForm.Subheading': 'Have you found a bug or do you have any comments/suggestions about this site?',
        'feedbackTypeForm.ButtonSpecific': 'Select and comment part of this page',
        'feedbackTypeForm.ButtonGeneral': 'General feedback about this page',
        'feedbackForm.Heading': 'Feedback',
        'feedbackForm.RatingLabel': 'How would you rate your experience?',
        'feedbackForm.TextLabel': 'Comment',
        'feedbackForm.TextPlaceholder': 'Write a comment or describe a problem.',
        'feedbackForm.EmailLabel': 'Your e-mail',
        'feedbackForm.EmailPlaceholder': 'john@example.com',
        'feedbackForm.EmailError': 'Please enter a valid e-mail address',
        'feedbackForm.NameLabel': 'Your name',
        'feedbackForm.TypeLabel': 'Feedback type',
        'feedbackForm.Types.1': 'Bug',
        'feedbackForm.Types.2': 'Improvement',
        'feedbackForm.Types.3': 'Question',
        'feedbackForm.Types.4': 'Feedback',
        'feedbackForm.ButtonSubmit': 'Submit feedback',
        'feedbackForm.ButtonCancel': 'Back',
        'feedbackForm.RequiredError': 'This field is required',
        'feedbackForm.OptionalText': '(optional)',
        'feedbackForm.AddScreenshot': 'Add screenshot',
        'feedbackForm.EditScreenshot': 'Edit screenshot',
        'feedbackForm.AddVideoClip': 'Record video clip',
        'feedbackForm.PreviewVideoClip': 'Preview video clip',
        'feedbackForm.MaxLengthError': 'This text is too long. Maximum is {max} characters',
        'feedbackForm.BeforeUnload': 'Are you sure you want to exit? Any feedback left will not be saved.',
        'highlighter.Cancel': 'Cancel',
        'highlighter.Undo': 'Undo',
        'highlighter.tools.Pencil': 'Pencil',
        'highlighter.tools.Interact': 'Interact',
        'highlighter.tools.Arrow': 'Arrow',
        'highlighter.tools.Rectangle': 'Rectangle',
        'highlighter.tools.ColorPicker': 'Color picker',
        'highlighter.tools.Obfuscate': 'Obfuscate',
        'highlighter.tools.Text': 'Add a comment',
        'highlighter.tools.Text.Placeholder': 'Type a comment',
        'highlighter.tools.Text.Save': 'Save comment',
        'highlighter.Done': 'Done',
        'thankYouModal.Heading': 'Thank You',
        'thankYouModal.Text': 'Your feedback has been sent successfully. Thank you.',
        'thankYouModal.Button': 'Close',
        'processingModal.Heading': 'Processing',
        'privacyTour.Title': 'Privacy tip',
        'privacyTour.Ok': 'Got it',
        'privacyTour.Obfuscate': 'Use this tool to obfuscate any personal information before sending your feedback.',
      },
    };
    const ybug = document.createElement('script');
    ybug.type = 'text/javascript';
    ybug.async = true;
    ybug.src = 'https://widget.ybug.io/button/' + window['ybug_settings'].id + '.js';

    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ybug, s);
  }
}
